import IBimehNamehDto from '../../../../../../../../Feature/Khodro/ShakhsSales/SakhsSalesBimehNameh/Commands/Estelam/IBimehNamehDto';

const BimehNamehInitialState: IBimehNamehDto = {
  tarikhShoroo: null,
  moddatBimehNamehId: undefined,
  taahodMaali: undefined,
  modatBimehNamehGhabl: undefined,
  tarikhSarresidGhabli: undefined,
  darsadTakhfifHavadesBG: undefined,
  vaziatKhesaratHavadesBGCoreId: undefined,
  darsadTakhfifSalesBG: undefined,
  vaziatKhesaratSalesBGCoreId: undefined,
};

export default BimehNamehInitialState;
